export enum OperationType {
  New = 0,
  Edited = 1,
  Deleted = 2
}
